import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import RestartAltTwoToneIcon from "@mui/icons-material/RestartAltTwoTone";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { ConfirmDangerModalComponent } from "@soqs/common";
import { cancelVerification } from "../features/AppSlice";

function SimpleDialog(props) {
  const { onClose, open } = props;
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle style={{ backgroundColor: "rgb(0,98,155)", color: "white" }}>
        Timeline Legend
      </DialogTitle>
      <List sx={{ pt: 0 }} style={{ backgroundColor: "rgb(221, 227, 238)" }}>
        <ListItem disableGutters>
          <ListItemButton autoFocus>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#3cb95f" }}>
                <AddIcon sx={{ color: "#3cb95f" }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Completed Step" />
          </ListItemButton>
        </ListItem>
        <ListItem disableGutters>
          <ListItemButton autoFocus>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#159ceb" }}>
                <AddIcon sx={{ color: "#159ceb" }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Current Step" />
          </ListItemButton>
        </ListItem>
        <ListItem disableGutters>
          <ListItemButton autoFocus>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: "#b5a6b5" }}>
                <AddIcon sx={{ color: "#b5a6b5" }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Future Step" />
          </ListItemButton>
        </ListItem>
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function SimpleDialogBox() {
  const dispatch = useDispatch();
  const [confirmClearModal, setConfirmClearModal] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box
        sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
      >
        <Tooltip title="Restart">
          <RestartAltTwoToneIcon
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "10px",
            }}
            aria-label="Restart"
            fontSize="medium"
            onClick={() => {
              setConfirmClearModal(true);
            }}
          />
        </Tooltip>
        &nbsp;&nbsp;
        <Tooltip title="Timeline Legend">
          <HelpOutlineIcon
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "10px",
            }}
            aria-label="Legend"
            fontSize="medium"
            onClick={handleClickOpen}
          />
        </Tooltip>
        <SimpleDialog open={open} onClose={handleClose} />
        <ConfirmDangerModalComponent
          open={confirmClearModal}
          onClose={() => {
            setConfirmClearModal(false);
          }}
          cbConfirm={() => {
            setConfirmClearModal(false);
            dispatch(cancelVerification());
          }}
          title="Restart Process"
          subheader="Are you sure you want to restart the process?"
          confirmText="Restart"
          cancelText="Cancel"
        />
      </Box>
      <Box
        sx={{ display: { xs: "none", sm: "none", md: "block", lg: "none" } }}
      >
        <Tooltip title="Restart">
          <RestartAltTwoToneIcon
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "12px",
            }}
            aria-label="Restart"
            fontSize="large"
            onClick={() => {
              setConfirmClearModal(true);
            }}
          />
        </Tooltip>
        &nbsp;&nbsp;
        <Tooltip title="Timeline Legend">
          <HelpOutlineIcon
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "10px",
            }}
            aria-label="Legend"
            fontSize="large"
            onClick={handleClickOpen}
          />
        </Tooltip>
        <SimpleDialog open={open} onClose={handleClose} />
        <ConfirmDangerModalComponent
          open={confirmClearModal}
          onClose={() => {
            setConfirmClearModal(false);
          }}
          cbConfirm={() => {
            setConfirmClearModal(false);
            dispatch(cancelVerification());
          }}
          title="Restart Process"
          subheader="Are you sure you want to restart the process?"
          confirmText="Restart"
          cancelText="Cancel"
        />
      </Box>
      <Box
        sx={{ display: { xs: "none", sm: "none", md: "none", lg: "block" } }}
      >
        <Tooltip title="Restart the Process">
          <Button
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "10px",
              verticalAlign: "top",
            }}
            variant="contained"
            startIcon={
              <RestartAltTwoToneIcon aria-label="Restart" fontSize="large" />
            }
            onClick={() => {
              setConfirmClearModal(true);
            }}
          >
            Restart
          </Button>
        </Tooltip>
        &nbsp;&nbsp;
        <Tooltip title="Timeline Legend">
          <Button
            sx={{
              color: "white",
              backgroundColor: "rgb(0, 98, 155)",
              border: "2pt solid white",
              borderRadius: "10px",
              verticalAlign: "top",
            }}
            variant="contained"
            startIcon={<HelpOutlineIcon aria-label="Legend" fontSize="large" />}
            onClick={handleClickOpen}
          >
            Legend
          </Button>
        </Tooltip>
        <SimpleDialog open={open} onClose={handleClose} />
        <ConfirmDangerModalComponent
          open={confirmClearModal}
          onClose={() => {
            setConfirmClearModal(false);
          }}
          cbConfirm={() => {
            setConfirmClearModal(false);
            dispatch(cancelVerification());
          }}
          title="Restart Process"
          subheader="Are you sure you want to restart the process?"
          confirmText="Restart"
          cancelText="Cancel"
        />
      </Box>
    </>
  );
}
